
    import { defineComponent } from 'vue';
    export default defineComponent({
        props: {
            sort: {
                type: String,
                required: false
            },
            dir: {
                type: String,
                required: false
            },
            items: {
                type: Array,
                default: [] as Array<unknown>
            },
            tableName: {
                type: Array,
                default: [] as Array<unknown>
            },
            loading: {
                type: Boolean,
                default: true
            }
        },
    })
